/** 逾期原因强控提醒字典编码 */
export const OVERDUE_REASONS_FORCE_CONTROL_REMINDER = 'EL_OVERDUE_REASONS_FORCE_CONTROL_REMINDER';

/** 数据字典：是否开启定时查询，值为 '1' 表示开启 */
export const OVERDUE_REASONS_FORCE_CONTROL_REMINDER_ENABLE = 'POLL_SWITCH';

/** 数据字典：定时查询间隔（分钟） */
export const OVERDUE_REASONS_FORCE_CONTROL_REMINDER_INTERVAL = 'POLL_INTERVAL';

/** 默认轮询间隔（分钟），字典未配置时使用 */
export const OVERDUE_REASONS_FORCE_CONTROL_REMINDER_DEFAULT_INTERVAL_MINUTES = 30;

/** 查询物流逾期未关单弹窗数据 */
export const OVERDUE_REASONS_FORCE_CONTROL_REMINDER_QUERY_URL =
  '/api-antms/query/logisticsOverdue/queryOverduePopup';

/** 导出报表字典编码（MDM 配置导出模板，对齐 OTP reportExport reportCode） */
export const OVERDUE_REASONS_FORCE_CONTROL_REMINDER_EXPORT_CODE =
  'EL_OVERDUE_REASONS_FORCE_CONTROL_REMINDER_EXPORT';

/** 去备注：OMS 任务中心路由 */
export const OVERDUE_REASONS_FORCE_CONTROL_REMINDER_TASK_CENTER_PATH = '/microOms/order-manage/task-center';

/** 去备注：批量查询任务单号上限 */
export const OVERDUE_REASONS_FORCE_CONTROL_REMINDER_BATCH_QUERY_MAX = 5000;

/** 本地缓存：各账号上次逾期强控弹窗展示时间（毫秒时间戳） */
export const OVERDUE_REASONS_FORCE_CONTROL_REMINDER_LAST_SHOW_STORAGE_KEY =
  'EL_OVERDUE_REASONS_FORCE_CONTROL_REMINDER_LAST_SHOW';
